export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      },
    },
    modalTitle: {
      type: String,
      default: null,
    },
    availableTags: {
      type: Object,
      default() {
        return {};
      },
    },
    hasQuickTagRemoval: {
      type: Boolean,
      default: true,
    },
    isSearchable: {
      type: Boolean,
      default: true,
    },
    searchKeys: {
      type: Array,
      default() {
        return ['name', 'parent'];
      },
    },
  },
  data() {
    return {
      searchTerm: '',
    };
  },
  methods: {
    newSearchTerm(term) {
      this.searchTerm = term;
    },
  },
};
